import { useState } from 'react'
import { emailCampaignFields as fields, getClassNameForField } from '../../constants'
import { EditableFormPage } from '../components/EditableFormPage'
import { Button } from '../../shared/components/Button'
import { FaEye, FaEyeSlash } from 'react-icons/fa'
import { useTranslation } from 'react-i18next'
import { useTranslationService } from '../../util/TranslationContext'

const NewsletterCampaignCreate = () => {
    const [preview, setPreview] = useState(false)
    const { t } = useTranslation()

    const { translateFields } = useTranslationService()
    const emailCampaignFields = translateFields(fields, 'newsletter')

    return (
        <>
            <div className='flex items-center justify-between'>
                <Button variant='primary' className='mb-4' onClick={() => setPreview(!preview)}>
                    {!preview ? <FaEye /> : <FaEyeSlash />} {t('status.preview')}
                </Button>
            </div>
            <EditableFormPage
                submitUrl='admin/newsletter-campaigns'
                fields={emailCampaignFields}
                classNameForField={getClassNameForField}
                create={true}
                navigateLink='/admin/auth/email-campaigns'
                previewEmail={preview}
            />
        </>
    )
}

export default NewsletterCampaignCreate
